export default "__VITE_ASSET__Dv$H5xg$__"